// Single source of truth for chart palette + global department list
export const CHART_PALETTE_DARK = ["#1E40FF", "#F5F1EA", "#A1A1AA", "#52525B", "#27272A"];
export const CHART_PALETTE_LIGHT = ["#1E40FF", "#0A1628", "#4B5563", "#9CA3AF", "#E5E7EB"];

export const SELLABLE_DEPTS = [
  "Sarees", "Mens Shirts", "Womens Kurti Set", "Mens Lower",
  "Boys", "Girls", "Mens Inner", "Footwear",
];

export const PERIODS = ["DAY", "WEEK", "MTD", "QTD", "YTD", "LTM"];
